import NoValueCheck from './NoValueCheck';

/**
 * ตรวจสอบค่า eGFR - มีการแบ่งระยะไตเสื่อมหลายระดับ
 * ไฟล์นี้ใช้ logic พิเศษ เพราะมีการแบ่งระดับความรุนแรง (Stage 1-5)
 * ไม่ได้ใช้ medium.json เหมือนไฟล์อื่น
 */
export default (value, age, gender) => {
  if (NoValueCheck(value)) return NoValueCheck(value);

  value = +value;

  // eGFR Stages (ตามมาตรฐานการแบ่งระยะไตเสื่อม)
  if (value > 90) {
    return {
      title: 'ไตปกติ',
      color: 'green',
      caption: 'ไตทำงานปกติ (eGFR > 90)',
      suggest: ''
    };
  } else if (value > 60) {
    return {
      title: 'ไตเสื่อมระยะที่ 2',
      color: 'green',
      caption: 'ไตทำงานลดลงเล็กน้อย (eGFR 60-90)',
      suggest: 'ควรตรวจติดตามอย่างสม่ำเสมอ'
    };
  } else if (value > 30) {
    return {
      title: 'ไตเสื่อมระยะที่ 3',
      color: 'red',
      caption: 'ไตทำงานลดลงปานกลาง (eGFR 30-60)',
      suggest: 'แนะนำให้ปรึกษาแพทย์เฉพาะทางไต'
    };
  } else if (value > 15) {
    return {
      title: 'ไตเสื่อมระยะที่ 4',
      color: 'red',
      caption: 'ไตทำงานลดลงมาก (eGFR 15-30)',
      suggest: 'จำเป็นต้องปรึกษาแพทย์เฉพาะทางไตเพื่อวางแผนการรักษา'
    };
  } else {
    return {
      title: 'ไตเสื่อมระยะสุดท้าย',
      color: 'red',
      caption: 'ไตวายระยะสุดท้าย (eGFR < 15)',
      suggest: 'จำเป็นต้องได้รับการบำบัดทดแทนไต (ฟอกเลือด หรือ ปลูกถ่ายไต)'
    };
  }
};
